import { keyEntry, project } from "../types/project/project";

const initialProject: project = {
    _id: "",
    accountId: "",
    name: "",
    description: "",
    baseLanguage: {
        name: "",
        isoCode: "",
        lang: ""
    },
    languages: [],
    users: [],
    access: [],
    groups: []
};

const initialKeyEntry: keyEntry = {
    uniqueId: "",
    key: "",
    name: "",
    translations: []
};

export { initialProject, initialKeyEntry };
